import React, { Component } from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo.png";

class Navbar extends Component {
  render() {
    return (
      <div className="head">
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <img style={{ height: "44px", width: "120px" }} src={Logo}></img>
        </div>

        <div>
          <h3
            style={{
              textAlign: "left",
              margin: "0",
              padding: "5px",
              fontSize: "21px",
              fontWeight: "bold",
              color: "#0a4a71",
              marginTop: "10px",
            }}
          >
            DGS
          </h3>
        </div>
      </div>
    );
  }
}

export default Navbar;
